module.exports = __webpack_public_path__ + "img/item_image_7.9f508237.jpg";